import { createStore } from '@stencil/store';

const dynamicBannerStore = createStore({
  data: undefined,
  question: undefined,
  scrolled: false,
  processed: false,
  isRefinement: false,
});

export default dynamicBannerStore;
